import { createClient } from '@/shared/api';
import type {
  SaveSignatureDateToReportMutation,
  SaveSignatureDateToReportMutationVariables,
} from '@/shared/api';
import SAVE_SIGNATURE_DATE_TO_REPORT_MUTATION from '../mutations/saveSignatureDateToReport';

/**
 * Stores the physician signature date on a report, keeping the persisted and rendered forms apart. Runs the saveSignatureDateToReport mutation with both the date saved to the database and the UTC value used for server-side rendering, and throws the returned message when it does not report success.
 *
 * @param id - Identifier of the report to sign.
 * @param signatureDate - Signature date persisted in the database.
 * @param signatureUTC - UTC signature value rendered by the server.
 * @returns A promise resolving once the signature date has been stored.
 */
const handleSaveSignatureDateToReport = async (id: any, signatureDate: any, signatureUTC: any) => {
  const client = createClient();
  //* signatureDate for save db
  //* signatureUTC to show render in server
  const result = await client.mutate<
    SaveSignatureDateToReportMutation,
    SaveSignatureDateToReportMutationVariables
  >({
    mutation: SAVE_SIGNATURE_DATE_TO_REPORT_MUTATION,
    variables: {
      id,
      signatureDate,
      signatureUTC,
    },
  });
  if (!result?.data?.saveSignatureDateToReport?.isSuccess) {
    throw new Error(result?.data?.saveSignatureDateToReport?.message ?? undefined);
  }
};

export default handleSaveSignatureDateToReport;
